import React, { useContext } from "react";
import { MessageContext } from "../../context/MessageContext";
import AppRouter from "../../routers";
import Message from "../Message";
import { Container } from "./styles";

const AppContainer = () => {
  const messageContext = useContext(MessageContext);

  return (
    <Container>
      {messageContext.show && (
        <div className="message-container">
          <Message {...messageContext} />
        </div>
      )}
      <AppRouter />
    </Container>
  );
};

export default AppContainer;
